import { render } from "./HYchannel.vue?vue&type=template&id=8d7c54de&scoped=true"
import script from "./HYchannel.vue?vue&type=script&lang=js"
export * from "./HYchannel.vue?vue&type=script&lang=js"

import "./HYchannel.vue?vue&type=style&index=0&id=8d7c54de&lang=scss&scoped=true"
import "./HYchannel.vue?vue&type=style&index=1&id=8d7c54de&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7c54de"]])

export default __exports__